import "./surf-break-webcams.scss"
import { BaseComponent } from "utils/base-component"
import { openWebcamPopup, WebcamPopupData } from "components/webcam-popup"

type RawModalData = WebcamPopupData & {
  image_url?: string
  special_url?: string
  special_type?: string
  aspect_ratio?: string | number
  credit_label?: string
  credit_url?: string
  distance_km?: string | number
  location_name?: string
  location_url?: string
}

function normalizeModalData(data: RawModalData): WebcamPopupData {
  return {
    name: data.name,
    imageUrl: data.imageUrl || data.image_url,
    specialUrl: data.specialUrl || data.special_url,
    specialType: data.specialType || data.special_type,
    aspectRatio: data.aspectRatio || data.aspect_ratio,
    creditLabel: data.creditLabel || data.credit_label,
    creditUrl: data.creditUrl || data.credit_url,
    distanceKm: data.distanceKm || data.distance_km,
    locationName: data.locationName || data.location_name,
    locationUrl: data.locationUrl || data.location_url,
  }
}

export class SurfBreakWebcams extends BaseComponent {
  static cssClass = "surf-break-webcams"

  init() {
    this.elements("preview-button").forEach((button) => {
      button.element.addEventListener("click", () => {
        const modalData = (button.element as HTMLButtonElement).dataset.modal
        if (!modalData) return

        openWebcamPopup(normalizeModalData(JSON.parse(modalData) as RawModalData))
      })
    })
  }
}
